module.exports = __webpack_public_path__ + "img/nostartbg.866bef38.png";